import baseUrl from "../config/baseUrl";

const changeFieldSettingsStatus = async ({ token, user_id, field_setting_id, status }) => {
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("field_setting_id", field_setting_id);
    formData.append("status", status);

    try {
        const response = await fetch(`${baseUrl}/api/update-field-setting-table-data?field_setting_id=${field_setting_id}&status=${status}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        const data = await response.json();
        return data;
    } catch (error) {
        return error;
    }
};

export default changeFieldSettingsStatus;
